<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-24 23:03:39
 * @LastEditTime: 2022-03-16 10:30:19
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
    <div class="dialog__box">

      <img
        v-if="[6,7].includes(state)"
        class="dialog-close"
        src="@/render/assets/images/home/dialog_close.png"
        alt="close"
        @click="close"
      />
      <div class="icon--payment">
        <img src="@/render/assets/images/personal/icon_payment_status_second.png" v-if="state === 6">
        <img src="@/render/assets/images/personal/icon_payment_status.png" v-else>
      </div>
      <div class="payment--result--desc" v-html="desc"></div>
      <div class="payment--result--options" v-if="state < 6">
        <div class="option" @click="$router.replace('/home')">返回首页</div>
        <div class="option" @click="$router.replace('/personal-order')" v-if="state == 4">查看考级申请</div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from './mixin'
export default {
  mixins: [dialogMixin],
  props: {
    state: {
      type: Number,
      require: true
    }
  },
  computed: {
    desc() {
      const descMapping = {
        2: '支付完成，请耐心等待证书办理，证书将顺丰到付<br/>邮寄，请注意查收！',
        4: '支付完成，请耐心等待考级申请审核,审核信息确认<br/>后将以短信方式告知!',
        5: '支付完成，并已完成审核，请前往首页以进行考级!',
        6: '核销完成，请前往进行考级！', // 使用激活码核销
        7: '申请完成，请前往进行考级！' // 0元免费申请考级
      }
      return descMapping[this.state]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./dialog.scss";
.dialog {
  &__box {
    position: relative;
    padding-top: val(50);
    width: val(500);
    height: val(350);
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .dialog-close {
      position: absolute;
      right: val(20);
      top: val(18);
      width: val(12);
      cursor: pointer;
    }
    .icon--payment {
      width: val(172);
      margin-bottom: val(22);
    }
    .payment--result--desc {
      font-size: val(16);
      font-weight: bold;
      line-height: val(24);
      color: #333333;
      text-align: center;
    }
    .payment--result--options {
      position: absolute;
      left: 0;
      right: 0;
      bottom: val(40);
      display: flex;
      justify-content: center;
      align-items: center;
      .option {
        cursor: pointer;
        font-size: val(18);
        color: #0077E8;
        margin-right: val(50);
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
}

</style>
